import { render } from "./HorizontalCheckbox.vue?vue&type=template&id=6ef26382"
import script from "./HorizontalCheckbox.vue?vue&type=script&lang=js"
export * from "./HorizontalCheckbox.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__